import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '@env';

export const authConfig: AuthConfig = {
  issuer: `${environment.idpBaseUrl}/realms/regentis`,
  redirectUri: `${window.location.protocol}//${window.location.host}`,
  clientId: 'regentis-app',
  responseType: 'code',
  scope: 'openid profile email',
  silentRefreshRedirectUri: `${window.location.protocol}//${window.location.host}/auth-silent-refresh.html`,
  silentRefreshTimeout: 5000,
  useSilentRefresh: true,
  showDebugInformation: !environment.prod,
  sessionChecksEnabled: false,
  timeoutFactor: 0.75,
  checkOrigin: true,
  preserveRequestedRoute: true,
  clearHashAfterLogin: false,
  requireHttps: environment.prod
};
